import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { useDispatch } from 'react-redux'
import { headKey } from '@/utils'
import { CreateFormValues } from '../types'
import ConfirmModal from '../components/confirm-modal'

type Props = {
  visible: boolean
  closeModal: () => void
  listingId: string | null
  values: CreateFormValues
}

const ListingRelistModal = ({ visible, closeModal, listingId, values }: Props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const duplicateData = async () => {
    const { body, error } = await dispatch.listing.cloneListing(listingId)
    if (!error) {
      closeModal()
      const newlistingId = headKey(body.listings)
      history.replace(`/listing/create/${newlistingId}/details`)
    }
  }

  const showBlankForm = async () => {
    const response = await dispatch.listing.create(values)
    closeModal()
    if (response.response.ok) {
      const newlistingId = headKey(response.body.listings)
      history.replace(`/listing/create/${newlistingId}/details`)
    }
  }

  return (
    <ConfirmModal
      visible={visible}
      onClose={closeModal}
      title={t('l.listing.create.relist.title', 'Re-list existing unit?')}
      subTitle={`${t('l.listing.relist_modal.description', 'It seems you have created this unit before.')} ${t(
        'l.listing.relist_modal_clone.description',
        'How would you like us to help you with your listing creation?'
      )}`}
      onConfirm={duplicateData}
      confirmText={t('l.listing.relist_modal_duplicate_data.button', 'Duplicate data')}
      onSecondary={showBlankForm}
      secondaryText={t('l.listing.relist_modal_use_blank.button', 'Use blank form')}
    />
  )
}

export default ListingRelistModal
